import styled from 'styled-components';

export const AddChatOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.7);
`;

export const AddChatModalCard = styled.div`
  width: 100%;
  max-width: 672px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background: #161616;
  border: 1px solid #262626;

  .header {
    padding: 24px 24px 16px;

    h3 {
      margin: 0 0 4px;
      font-size: 18px;
      font-weight: 600;
      color: var(--white);
    }

    .subtitle {
      margin: 0 0 16px;
      font-size: 14px;
      line-height: 20px;
      color: #707070;
    }

    .search {
      position: relative;

      svg {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #606060;
        pointer-events: none;
      }

      input {
        width: 100%;
        padding: 8px 12px 8px 36px;
        border-radius: 8px;
        border: 1px solid #262626;
        background: #0e0e0e;
        color: var(--white);
        font-size: 14px;
        outline: none;

        &::placeholder {
          color: #606060;
        }

        &:focus {
          border-color: rgba(3, 160, 141, 0.4);
        }
      }
    }
  }

  .list {
    flex: 1;
    overflow-y: auto;
    padding: 0 24px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .loading,
  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 64px 16px;
    font-size: 14px;
    color: #707070;
  }

  .loading {
    color: var(--primary);

    .spin {
      animation: spin 0.9s linear infinite;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .session {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #262626;
    background: #0e0e0e;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease;

    &:hover {
      border-color: #333;
    }

    &.selected {
      border-color: rgba(3, 160, 141, 0.5);
      background: rgba(3, 160, 141, 0.05);
    }

    .check {
      width: 18px;
      height: 18px;
      margin-top: 2px;
      border-radius: 4px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #3a3a3a;
      color: var(--white);

      &.on {
        background: var(--primary);
        border-color: var(--primary);
      }
    }

    .meta {
      flex: 1;
      min-width: 0;
    }

    .title {
      display: block;
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: var(--white);
      text-transform: capitalize;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .desc {
      margin: 2px 0 0;
      font-size: 12px;
      line-height: 16px;
      color: #a0a0a0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .date {
      display: block;
      margin-top: 4px;
      font-size: 10px;
      color: #606060;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 24px;
    border-top: 1px solid #262626;

    button {
      padding: 8px 16px;
      border: 0;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
    }

    .cancel {
      background: transparent;
      color: #a0a0a0;

      &:hover {
        color: var(--white);
      }
    }

    .submit {
      background: var(--primary);
      color: var(--white);
      font-weight: 500;

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;

/** Kept for leftover imports */
export const StyledAddChatModal = AddChatModalCard;
